import { Injectable } from '@angular/core';
//import newrelic from '@newrelic/browser-agent';

@Injectable({
  providedIn: 'root'
})
export class NewRelicService {
  private newRelicAgent: any = null


  /**
   * Add a custom page action event to New Relic.
   * @param actionName - The name of the action.
   * @param attributes - Additional attributes to log with the action.
   */
  addPageAction(actionName: string, attributes: { [key: string]: any }): void {
    // if (window && window['NREUM']) {
    //  window['NREUM'].addPageAction(actionName, attributes);
    // } else {
    //   console.error('New Relic agent not initialized');
    // }
  }
  noticeError(err: Error, attributes?: { [key: string]: any }): void {
    if (window && window['NREUM']) {
      if (attributes) {
        window['NREUM'].noticeError(err, attributes);
      } else {
        window['NREUM'].noticeError(err);
      }
      console.error('Error noticed', err, attributes);
    } else {
      console.error('New Relic agent not initialized');
    }
  }
  setPageViewName(name: string): void {
    if (window && window['NREUM']) {
      window['NREUM'].setPageViewName(name);
      console.log(`Page view name set to "${name}"`);
    } else {
      console.error('New Relic agent not initialized');
    }
  }
  setCurrentRouteName(name: string): void {
    if (window && window['NREUM']) {
      window['NREUM'].setCurrentRouteName(name);
      console.log(`Current route name set to "${name}"`);
    } else {
      console.error('New Relic agent not initialized');
    }
  }

}